import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error'
import {  useNavigate } from "react-router-dom";

const Invoice = ({ work_order, onWorkOrderChange, invoice_add_mode, readOnly=false }) => {
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [invoice, setInvoice] = useState(null);
    const [caseManager, setCaseManager] = useState(null);
    const [invoiceAdd, setInvoiceAdd] = useState(null);
    const [inputError, setInputError] = useState(false);



  

    useEffect(() => {
       
        if (work_order?.work_order_id > 0 && work_order?.status >= 4) {
            getInvoice();
            getCaseManagerById(work_order?.case_manager_id,work_order?.client_id );

        }


    }, [work_order?.work_order_id, work_order?.status]);

    useEffect(() => {
        setAddMode(invoice_add_mode);
        setEditMode(false);
    }, [invoice_add_mode]);


    

    const getCaseManagerById = async (case_manager_id,client_id) => {
    

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-case-manager-by-id/" + case_manager_id+"/"+client_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setCaseManager(response?.data?.case_manager);

            } else {

                Swal.fire({ icon: "error", title: "Case Manager Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error,navigate)

        });

    
    }

    const getInvoice = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-invoice-by-work-order-id/"+ work_order?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setInvoice(response?.data?.invoice)



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error,navigate)


            });


    }


    const addInvoice = async () => {

        setInvoiceAdd({
            invoice_facility_fee:parseFloat(work_order?.facility_fee?work_order?.facility_fee:0.00).toFixed(2),
            invoice_client_fee:parseFloat(work_order?.client_fee?work_order?.client_fee:0.00).toFixed(2),
            invoice_misc_fee:0.00.toFixed(2),
            invoice_recipient_email:caseManager?.case_manager_email
        });
        setAddMode(true);

    }


    const saveInvoice = async (e) => {


        setIsBtn(true);
        let error_flag = false;

        const { invoice_facility_fee, invoice_client_fee, invoice_misc_fee,is_dollar_40 } = invoiceAdd;
        if (!invoice_facility_fee || !invoice_client_fee || !invoice_client_fee?.toString().match(/^[0-9]*\.\d{1,2}$/) || 
        !invoice_facility_fee?.toString().match(/^[0-9]*\.\d{1,2}$/) ||  (is_dollar_40 && !is_dollar_40?.toString().match(/^[0-9]*\.\d{1,2}$/)) ||
         (invoice_facility_fee * 1 + invoice_client_fee * 1 + invoice_misc_fee * 1) < 1) {

            setInputError(true);
            setIsBtn(false);

        } else if((invoiceAdd?.invoice_notes == null || invoiceAdd?.invoice_notes == "") && !work_order?.medical_record_file) 
        {

            Swal.fire({ icon: "error", title: "Invoice Error", text: "Please add invoice notes, as medical record files are being overridden." });
            setIsBtn(false);
        }
            else {

            var invoice_info = {
                work_order_id: work_order?.work_order_id,
                invoice_facility_fee: invoiceAdd?.invoice_facility_fee,
                invoice_client_fee: invoiceAdd?.invoice_client_fee,
                invoice_misc_fee: invoiceAdd?.invoice_misc_fee,
                invoice_notes: invoiceAdd?.invoice_notes,
                invoice_internal_notes: invoiceAdd?.invoice_internal_notes,
                is_dollar_40: invoiceAdd?.is_dollar_40,
                is_credit_card: invoiceAdd?.is_credit_card,
                invoice_recipient_email:invoiceAdd?.invoice_recipient_email
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-invoice", invoice_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    invoice_info.invoice_id = response?.data?.invoice_id;
                    setInvoice(invoice_info);
                    setEditMode(false)
                    setAddMode(false)
                    onWorkOrderChange({ status: 5 });

                } else {

                    Swal.fire({ icon: "error", title: "Invoice Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error,navigate)

            });

        }


    }



    const updateInvoice = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { invoice_facility_fee, invoice_client_fee, invoice_misc_fee,is_dollar_40 } = invoice;
        if (!invoice_facility_fee || !invoice_client_fee || !invoice_client_fee?.toString()?.match(/^[0-9]*\.\d{1,2}$/) || 
            !invoice_facility_fee?.toString()?.match(/^[0-9]*\.\d{1,2}$/) ||   (is_dollar_40 && !is_dollar_40?.toString()?.match(/^[0-9]*\.\d{1,2}$/)) ||
            (invoice_facility_fee * 1 + invoice_client_fee * 1 + invoice_misc_fee * 1) < 1) {


            setInputError(true);
            setIsBtn(false);

        } else {

            var invoice_info = {
                work_order_id: work_order?.work_order_id,
                invoice_id: invoice?.invoice_id,
                invoice_facility_fee: invoice?.invoice_facility_fee,
                invoice_client_fee: invoice?.invoice_client_fee,
                invoice_misc_fee: invoice?.invoice_misc_fee,
                invoice_notes: invoice?.invoice_notes,
                invoice_internal_notes: invoice?.invoice_internal_notes,
                is_dollar_40: invoice?.is_dollar_40,
                is_credit_card: invoice?.is_credit_card,
                invoice_recipient_email:invoice?.invoice_recipient_email
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-invoice", invoice_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setInvoice(invoice_info);
                    onWorkOrderChange({ status: response?.data?.wo_status });
                    setEditMode(false)
                    setAddMode(false)


                } else {

                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error,navigate)

            });

        }


    }

    const editInvoice = async()=>{


        setEditMode(true); 
         setInvoice({ ...invoice, 
            invoice_recipient_email: invoice?.invoice_recipient_email,
            invoice_facility_fee: parseFloat(invoice?.invoice_facility_fee).toFixed(2),
            invoice_client_fee: parseFloat(invoice?.invoice_client_fee).toFixed(2),
            invoice_misc_fee: parseFloat(invoice?.invoice_misc_fee).toFixed(2),
            is_dollar_40: parseFloat(invoice?.is_dollar_40).toFixed(2),
         })

    }


    return (
        <>


            {(work_order?.status >= 4) &&

                <>
                    <div className="row mt-2 mx-0 sub-heading">
                        <div className="col py-1">

                            <div className=" px-3 py-2 fw-bold text-dark">Invoice</div>

                        </div>
                        <div className="col py-1 text-end">



                            {addMode ? 
                            <>
                                    <button onClick={() => saveInvoice()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SAVE"}</button>
                                    <button onClick={() => { setAddMode(false); setInvoiceAdd(null); }} className="btn btn-sm  btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>
                                    </>
                                :
                                <>
                                    {editMode ?
                                        <>
                                            <button onClick={() => updateInvoice()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"UPDATE"}</button>
                                            <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 mt-1" type="button">CANCEL UPDATE</button>
                                        </>

                                        :
                                        <>
                                            {(invoice?.invoice_id > 0) ?
                                            <>
                                            {!readOnly && <button disabled={work_order.status>6} onClick={() => {editInvoice()}} className="btn btn-sm    btn-success me-1 mt-1" type="button">Manage Invoice</button>}
                                                <a href={"/admin/invoice-print/"+work_order.work_order_id} className="btn btn-sm    btn-warning me-1 mt-1" type="button" target="_blank">Print Invoice</a>
                                         
                                            </>
                                                :
                                              <>  
                                            {!readOnly && 
                                                <button disabled={work_order.status<4 || work_order.status>6} onClick={() => addInvoice()} className="btn btn-sm    btn-success me-1 mt-1" type="button">Add Invoice</button>
                                            }
                                            </>
                                           }
                                        </>
                                    }
                                </>
                            }

                        </div>


                    </div>

                    {(addMode) ?
                        <>


                            <form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                <div className="row px-3 py-2 gx-2 ">
                                <div className="col-md-3 col-sm-6">
                                        <label className="control-label">MAIL TO:</label><br/>
                                        <input name="invoice_recipient_email" className="form-control"
                                            value={invoiceAdd?.invoice_recipient_email}
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, invoice_recipient_email: e.target.value })
                                            }

                                        />
                                       
                                    </div>
                                    <div className="col-md-3 col-sm-6">
                                        <label className="control-label">Facility Fee:$dd.cc</label><br/>
                                        <input name="invoice_facility_fee" className="form-control"
                                            value={invoiceAdd?.invoice_facility_fee}
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, invoice_facility_fee: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!invoiceAdd?.invoice_facility_fee || !invoiceAdd?.invoice_facility_fee.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter facility fee in dd.cc format</span>
                                            )}
                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">Client Fee:$dd.cc</label><br/>

                                        <input name="invoice_client_fee" className="form-control"
                                            value={invoiceAdd?.invoice_client_fee}
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, invoice_client_fee: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!invoiceAdd?.invoice_client_fee || !invoiceAdd?.invoice_client_fee.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter invoice fee in dd.cc format</span>
                                            )}


                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">Misc Fee:$dd.cc</label><br/>
                                        <input name="invoice_misc_fee" className="form-control"
                                            value={invoiceAdd?.invoice_misc_fee}
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, invoice_misc_fee: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!invoiceAdd?.invoice_misc_fee || !invoiceAdd?.invoice_misc_fee.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter invoice miscellaneous fee in dd.cc format</span>
                                            )}


                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">TOTAL FEE:</label><br/>
                                        <input name="invoice_misc_fee" className="form-control" readOnly
                                            value={(invoiceAdd?.invoice_facility_fee * 1 + invoiceAdd?.invoice_client_fee * 1 + invoiceAdd?.invoice_misc_fee * 1).toFixed(2)}
                                            
                                        />
                                        {inputError &&
                                            ((invoiceAdd?.invoice_facility_fee * 1 + invoiceAdd?.invoice_client_fee * 1 + invoiceAdd?.invoice_misc_fee * 1) < 1) && (
                                                <span className="text-danger">All fee must add up to at least $1.00</span>
                                            )}


                                    </div>
                                </div>


                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-3">
                                        <label htmlFor="invoice_notes">INVOICE NOTES</label><br/>
                                        <textarea rows="1" name="invoice_notes" id="invoice_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, invoice_notes: e.target.value })
                                            }

                                        >
                                            {invoiceAdd?.invoice_notes}
                                        </textarea>


                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="invoice_internal_notes">INVOICE MEDRECAPS NOTES</label><br/>

                                        <textarea rows="1" name="invoice_internal_notes" id="invoice_internal_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, invoice_internal_notes: e.target.value })
                                            }
                                            
                                        >
                                            {invoiceAdd?.invoice_internal_notes}
                                        </textarea>

                                    </div>
                                    
                                    <div className="col-md-2 col-sm-3">
                                        <label className="control-label">T/F:$dd.cc</label><br/>

                                        <input name="is_dollar_40" className="form-control"
                                            value={invoiceAdd?.is_dollar_40}
                                            onChange={(e) =>
                                                setInvoiceAdd({ ...invoiceAdd, is_dollar_40: e.target.value })
                                            }s

                                        />
                                           {inputError &&
                                                (invoiceAdd?.is_dollar_40 && !invoiceAdd?.is_dollar_40?.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                    <span className="text-danger">Please enter in $dd.cc format</span>
                                                )}
                                    </div>
                                    <div className="col-md-4 col-sm-3">
                                        <label className="control-label">PAYMENT:</label><br/>
                                        <div className="mt-1">
                                        <input type="radio" className="form-check-input " name="is_credit_card" value="1"
            onClick={() => setInvoiceAdd({ ...invoiceAdd, is_credit_card: 1 })} checked={(invoiceAdd?.is_credit_card == 1) ? "true" : ""} /> CREDIT CARD
        <input type="radio" className="form-check-input ms-3" name="is_credit_card" value="0"
            onClick={() => setInvoiceAdd({ ...invoiceAdd, is_credit_card: 0 })} checked={(invoiceAdd?.is_credit_card == 0) ? "true" : ""} /> CHECK
</div>
                                        
                                    </div>
                                   
                                </div>


                            </form>

                        </>
                        :
                        <>
                            {(editMode) ?
                                <>

                              
    
<form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                <div className="row px-3 py-2 gx-2 ">
                                <div className="col-md-3 col-sm-6">
                                        <label className="control-label">MAIL TO:</label><br/>
                                        <input name="invoice_recipient_email" className="form-control"
                                            value={invoice?.invoice_recipient_email}
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, invoice_recipient_email: e.target.value })
                                            }

                                        />
                                       
                                    </div>
                                    <div className="col-md-3 col-sm-6">
                                        <label className="control-label">Facility Fee:$dd.cc</label><br/>
                                        <input name="invoice_facility_fee" className="form-control"
                                            value={invoice?.invoice_facility_fee}
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, invoice_facility_fee: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!invoice?.invoice_facility_fee || !invoice?.invoice_facility_fee.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter facility fee in dd.cc format</span>
                                            )}
                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">Client Fee:$dd.cc</label><br/>

                                        <input name="invoice_client_fee" className="form-control"
                                            value={invoice?.invoice_client_fee}
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, invoice_client_fee: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!invoice?.invoice_client_fee || !invoice?.invoice_client_fee.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter invoice fee in dd.cc format</span>
                                            )}


                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">Misc Fee:$dd.cc</label><br/>
                                        <input name="invoice_misc_fee" className="form-control"
                                            value={invoice?.invoice_misc_fee}
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, invoice_misc_fee: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!invoice?.invoice_misc_fee || !invoice?.invoice_misc_fee.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter invoice miscellaneous fee in dd.cc format</span>
                                            )}


                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">TOTAL FEE:</label><br/>
                                        <input name="invoice_misc_fee" className="form-control" readOnly
                                            value={parseFloat(invoice?.invoice_facility_fee * 1 + invoice?.invoice_client_fee * 1 + invoice?.invoice_misc_fee * 1).toFixed(2)}
                                            
                                        />
                                        {inputError &&
                                            ((invoice?.invoice_facility_fee * 1 + invoice?.invoice_client_fee * 1 + invoice?.invoice_misc_fee * 1) < 1) && (
                                                <span className="text-danger">All fee must add up to at least $1.00</span>
                                            )}


                                    </div>
                                </div>


                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-3">
                                        <label htmlFor="invoice_notes">INVOICE NOTES</label>
                                        <textarea rows="1" name="invoice_notes" id="invoice_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, invoice_notes: e.target.value })
                                            }

                                        >
                                            {invoice?.invoice_notes}
                                        </textarea>


                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="invoice_internal_notes">INVOICE MEDRECAPS NOTES</label>

                                        <textarea rows="1" name="invoice_internal_notes" id="invoice_internal_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, invoice_internal_notes: e.target.value })
                                            }
                                            
                                        >
                                            {invoice?.invoice_internal_notes}
                                        </textarea>

                                    </div>

                                   
                                    <div className="col-md-2 col-sm-2">
                                        <label className="control-label">T/F:$dd.cc</label>

                                        <input name="is_dollar_40" className="form-control"
                                            value={invoice?.is_dollar_40}
                                            onChange={(e) =>
                                                setInvoice({ ...invoice, is_dollar_40: e.target.value })
                                            }s

                                        />
                                           {inputError &&
                                                ( !invoice?.is_dollar_40?.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                    <span className="text-danger">Please enter in $dd.cc format</span>
                                                )}
                                    </div>
                                    <div className="col-md-4 col-sm-2">
                                        <label className="control-label">PAYMENT:</label>
                                        <div className="mt-1">
                                        <input type="radio" className="form-check-input " name="is_credit_card" value="1"
            onClick={() => setInvoice({ ...invoice, is_credit_card: 1 })} checked={(invoice?.is_credit_card == 1) ? "true" : ""} /> CREDIT CARD
        <input type="radio" className="form-check-input ms-3" name="is_credit_card" value="0"
            onClick={() => setInvoice({ ...invoice, is_credit_card: 0 })} checked={(invoice?.is_credit_card == 0) ? "true" : ""} /> CHECK
</div>
                                        
                                    </div>
                                   
                                </div>


                            </form>

    
                            </>
                                :
                                <>
                                    {(invoice?.invoice_id > 0) ?
                                        <>

                                <div className="row px-3 py-2 gx-2 ">
                                <div className="col-md-3 col-sm-6">
                                        <label htmlFor="invoice_recipient_email">MAIL TO:</label><br/>
                                        <label className="field-info  tt-none" >{invoice?.invoice_recipient_email?invoice?.invoice_recipient_email:""}</label>

                                       
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Facility Fee: </label><br/>
                                        <label className="field-info" >${parseFloat(invoice?.invoice_facility_fee).toFixed(2)}</label>
                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">Client Fee:</label><br/>

                                        <label className="field-info" >${parseFloat(invoice?.invoice_client_fee).toFixed(2)}</label>


                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">Misc Fee:</label><br/>
                                        <label className="field-info" >{invoice?.invoice_misc_fee?'$'+parseFloat(invoice?.invoice_misc_fee).toFixed(2):""}</label>

                                    </div>
                                    <div className="col-md-2 col-sm-6">
                                        <label className="control-label">TOTAL FEE:</label><br/>
                                        <label className="field-info" >${parseFloat(invoice?.invoice_facility_fee*1+invoice?.invoice_client_fee*1+invoice?.invoice_misc_fee*1).toFixed(2)}</label>


                                    </div>
                                </div>


                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-3">
                                        <label htmlFor="invoice_notes">INVOICE NOTES:</label><br/>
                                        <label className="field-info tt-none" >{invoice?.invoice_notes?invoice?.invoice_notes:""}</label>



                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="invoice_internal_notes">INVOICE MEDRECAPS NOTES:</label><br/>

                                        <label className="field-info" >{invoice?.invoice_internal_notes?invoice?.invoice_internal_notes:""}</label>


                                    </div>


                                   
                                    <div className="col-md-2 col-sm-6">
                                        <label htmlFor="is_dollar_40">T/F:</label><br/>

                                        <label className="field-info" >{invoice?.is_dollar_40?parseFloat(invoice?.is_dollar_40).toFixed(2):""}</label>

                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                        <label className="control-label">PAYMENT:</label><br/>
                                        <label className="field-info" >{invoice?.is_credit_card == 1?"CREDIT CARD":"CHECK"}</label>

                                    </div>
                                   
                                </div>


    

                                    </>
                                        :
                                        <div className="row " >

                                            <div className="col-xl-12 col-lg-12 py-4 px-3" >

                                                <h5>No invoice has been generated yet.</h5>

                                            </div>

                                        </div>
                                    }
                                </>
                            }

                        </>
                    }


                </>
            }
        </>
    )

}
export default Invoice;